"use client";

import SearchSvg from "../../assets/animations/search.animated.svg";
import { SvgAnimation, type SvgAnimationProps } from "../svg-animation/svg-animation";

/** A single spin (a hover) eases out into its stop; the flipbook's frames are evenly timed. */
const SEARCH_RUN_EASING = "cubic-bezier(0.3, 0, 0.2, 1)";

export function SearchAnimation(props: SvgAnimationProps) {
  return <SvgAnimation autoplay loop {...props} runEasing={SEARCH_RUN_EASING} svg={SearchSvg} />;
}
